import store from "@/store/index";
const checkOnlineStatus = () => store.commit("setOnline", window.navigator.onLine);
export { checkOnlineStatus };
